import { Heading, Layout, Text } from '../../../components/core';
import { getStylesheet } from '../../../styles';
import { ConnectNowAvailabilityStatuses } from '../connectNowTypes';
import { ContactMethodWithAvailability } from '../hooks/useConnectNowContactMethods';
import { OfflineBadge } from './OfflineBadge';

type ContactMethodProps = {
  method: ContactMethodWithAvailability;
};

export const ContactMethod = ({ method }: ContactMethodProps): JSX.Element => {
  const { availabilityStatus, availableElement, is247, title } = method;

  const subtitle = is247
    ? 'Available 24/7'
    : 'Available everyday from 12pm-12am ET, excluding major holidays.';

  const action =
    availabilityStatus === ConnectNowAvailabilityStatuses.Available ? (
      availableElement
    ) : (
      <OfflineBadge type={availabilityStatus} />
    );

  return (
    <Layout.HStack {...styles.container} space={10}>
      <Layout.VStack {...styles.textArea} space={1}>
        <Heading.h5
          level={3}
          aria-label={
            availabilityStatus !== ConnectNowAvailabilityStatuses.Available
              ? `${title} (currently offline)`
              : title
          }
        >
          {title}
        </Heading.h5>

        <Text.caption>{subtitle}</Text.caption>
      </Layout.VStack>

      <Layout.View {...styles.callToAction}>{action}</Layout.View>
    </Layout.HStack>
  );
};

const styles = getStylesheet({
  callToAction: {
    maxWidth: '200px',
    width: '50%',
    justifyContent: 'center',
  },
  container: {
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 4,
    paddingY: 2,
  },
  textArea: {
    flex: 1,
    minWidth: 0,
  },
});
